import { FirebaseOptions } from '@firebase/app';

import { isPreview, isProduction, isStaging } from 'helpers/environment';

const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string;

const getFirebaseConfig = (): FirebaseOptions => {
  if (isProduction) {
    return {
      apiKey,
      authDomain: 'nullifyrisk-production.firebaseapp.com',
      projectId: 'nullifyrisk-production',
      storageBucket: 'nullifyrisk-production.firebasestorage.app',
      messagingSenderId: '1058327817999',
      appId: '1:1058327817999:web:7381ddf0b5f7dfd9d3587a',
      measurementId: 'G-0PHLWJDSD2',
    };
  } else if (isPreview || isStaging) {
    return {
      apiKey,
      authDomain: 'sidejuice-dev.firebaseapp.com',
      projectId: 'sidejuice-dev',
      storageBucket: 'sidejuice-dev.firebasestorage.app',
      messagingSenderId: '522261853853',
      appId: '1:522261853853:web:93ed67fb06e153fcb54674',
    };
  }

  return {
    apiKey,
    authDomain: 'nullifyrisk-dev.firebaseapp.com',
    projectId: 'nullifyrisk-dev',
    storageBucket: 'nullifyrisk-dev.firebasestorage.app',
    messagingSenderId: '85348200510',
    appId: '1:85348200510:web:38ab94fc5276d25c6ae16f',
  };
};

const firebaseConfig = getFirebaseConfig();
export default firebaseConfig;
